import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailDiagnosticComponent } from './detail-diagnostic/detail-diagnostic.component';
import { SummaryDiagnosticComponent } from './summary-diagnostic/summary-diagnostic.component';
import { FormsModule } from '@angular/forms';
import { DiagnosticFilterComponent } from './diagnostic-filter/diagnostic-filter.component';
import { KpiBoxComponent } from './summary-diagnostic/kpi-box/kpi-box.component';
import { DataTableComponent } from './summary-diagnostic/data-table/data-table.component';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { AppNgMaterialModule } from '../app-ng-material.module';
// import { AddEditComponent } from './add-edit/add-edit.component';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
// import { EditDashboardChartDetailsComponent } from './add-edit/edit-dashboard-chart-details/edit-dashboard-chart-details.component';
import { DashboardFilterComponent } from './dashboard-filter/dashboard.filter.component';
import { DetailDiagViewComponent } from './summary-diagnostic/data-table/detail-diag-view/detail-diag-view.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DetailDiagnosticDataTableComponent } from './detail-diagnostic/detail-diagnostic-data-table/detail-diagnostic-data-table.component';
import { FilterComponent } from './filter/filter.component';

@NgModule({
  declarations: [
    DetailDiagnosticComponent, 
    SummaryDiagnosticComponent,
    DiagnosticFilterComponent, KpiBoxComponent, DataTableComponent , 
    DashboardFilterComponent, DetailDiagViewComponent,
    DetailDiagnosticDataTableComponent,
    FilterComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedComponentsModule,
    AppNgMaterialModule,
    AppNgAppkitModule,
    ScrollingModule,
  ],
  exports: [DetailDiagnosticComponent, SummaryDiagnosticComponent,
    DiagnosticFilterComponent, KpiBoxComponent, DashboardFilterComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class DiagnosticDashboardModule { }
